import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageStage728x90Gak from './gak/DesktopDevPageStage728x90';
import DesktopDevPageStage728x90Hahstag from './hashtag/DesktopDevPageStage728x90';
const DesktopDevPageStage728x90 = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90Hahstag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
